module.exports = __webpack_public_path__ + "img/logo@2x.417e27c0.png";